/* Sketchfoxx · bộ chọn Fabric / Size / Color (02j + sửa lỗi "Unavailable" 4/10/2026).
   - Đọc option theo TÊN (Size/Color/Fabric), chạy cả sản phẩm chưa có Fabric và baby.
   - Size: chỉ ẩn size không có ở BẤT KỲ màu nào của loại vải đang chọn.
   - Color: tổ hợp không có -> gạch chéo, không bấm được, tooltip "Not available in this size".
   - Đổi Fabric/Color làm size đang chọn không còn -> tự chuyển size gần nhất + 1 dòng ghi chú.
   - Không bao giờ để tổ hợp không tồn tại được gửi lên (bắt sự kiện change ở pha capture, trước Horizon).
   Không đụng giỏ hàng. */
(function () {
  function J(id) { try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return null; } }
  var data = J('sfx-variants'); if (!data) return;
  var lines = J('sfx-fabric-lines') || {};
  var names = (data.options || []).map(function (n) { return String(n).trim().toLowerCase(); });
  var iSize = names.indexOf('size'), iColor = names.indexOf('color'), iFab = names.indexOf('fabric');
  if (iColor < 0) iColor = names.indexOf('colour');
  var V = data.variants || [];
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', 'NB', '0-3M', '3M', '3-6M', '6M', '6-12M', '12M', '18M', '24M', '2T', '3T', '4T', '5T'];
  var dataSizes = []; V.forEach(function (v) { if (iSize >= 0 && dataSizes.indexOf(v.o[iSize]) < 0) dataSizes.push(v.o[iSize]); });
  function rank(s) { var i = ORDER.indexOf(String(s).toUpperCase()); return i < 0 ? 100 + dataSizes.indexOf(s) : i; }
  var SIZES = dataSizes.slice().sort(function (a, b) { return rank(a) - rank(b); });
  var note = null;

  function money(c) { return '$' + (c % 100 === 0 ? (c / 100).toFixed(0) : (c / 100).toFixed(2)); }
  function root() { return document.querySelector('.product-details') || document; }
  function fieldsets() { return [].slice.call(root().querySelectorAll('fieldset.variant-option')); }
  function kindOf(fs) {
    var i = fs && fs.querySelector('input[type="radio"]'); if (!i) return null;
    var n = String(i.name || '').split('-')[0].trim().toLowerCase();
    if (n === 'colour') n = 'color';
    if (n === 'size' || n === 'color' || n === 'fabric') return n;
    var l = fs.querySelector('legend'), t = l ? l.textContent.toLowerCase() : '';
    return /fabric/.test(t) ? 'fabric' : /colou?r/.test(t) ? 'color' : /size/.test(t) ? 'size' : null;
  }
  function fsOf(kind) { return fieldsets().find(function (f) { return kindOf(f) === kind; }) || null; }
  function selected(fs) { if (!fs) return null; var c = fs.querySelector('input:checked'); return c ? c.value : null; }
  function inputOf(lb) { return lb.querySelector('input') || (lb.htmlFor && document.getElementById(lb.htmlFor)); }
  function labelValue(lb) { var inp = inputOf(lb); return inp ? inp.value : (lb.textContent || '').trim(); }
  function match(v, s, c, f) {
    return (iSize < 0 || s == null || v.o[iSize] === s) && (iColor < 0 || c == null || v.o[iColor] === c) && (iFab < 0 || f == null || v.o[iFab] === f);
  }
  function has(s, c, f) { return V.some(function (v) { return match(v, s, c, f); }); }
  function sizesFor(c, f) { return SIZES.filter(function (s) { return has(s, c, f); }); }
  function nearest(size, list) {
    if (!list.length) return null; if (list.indexOf(size) >= 0) return size;
    var r = rank(size), best = null, bd = Infinity;
    list.forEach(function (s) { var d = Math.abs(rank(s) - r); if (d < bd || (d === bd && rank(s) > rank(best))) { bd = d; best = s; } });
    return best;
  }
  function ranges(list) {
    var idx = list.map(function (s) { return SIZES.indexOf(s); }).sort(function (a, b) { return a - b; }), out = [], st = null, pv = null;
    idx.forEach(function (i) { if (st === null) { st = pv = i; } else if (i === pv + 1) { pv = i; } else { out.push([st, pv]); st = pv = i; } });
    if (st !== null) out.push([st, pv]);
    return out.map(function (p) { return p[0] === p[1] ? SIZES[p[0]] : SIZES[p[0]] + '–' + SIZES[p[1]]; }).join(', ');
  }
  function state() {
    return { size: selected(fsOf('size')), color: selected(fsOf('color')), fab: iFab >= 0 ? (selected(fsOf('fabric')) || null) : null };
  }
  function check(kind, val) {
    var fs = fsOf(kind); if (!fs || val == null) return;
    [].slice.call(fs.querySelectorAll('input[type="radio"]')).forEach(function (i) {
      var on = i.value === val; i.checked = on;
      i.dataset.currentChecked = on ? 'true' : 'false';
      if (on) i.setAttribute('checked', ''); else i.removeAttribute('checked');
    });
  }

  // Sửa tổ hợp TRƯỚC khi Horizon đọc lựa chọn (capture phase chạy trước listener của <variant-picker>)
  document.addEventListener('change', function (ev) {
    var t = ev.target; if (!(t instanceof HTMLInputElement) || t.type !== 'radio') return;
    var fs = t.closest('fieldset.variant-option'); if (!fs || !fs.closest('.product-details')) return;
    var which = kindOf(fs); if (!which) return;
    var st = state();
    note = null; // ghi chú chỉ hiện ngay sau lần tự chuyển; lần chọn kế tiếp xoá
    if (iSize < 0 || st.size == null || has(st.size, st.color, st.fab)) return;
    var fix = { size: st.size, color: st.color };
    if (which === 'size') {
      // size có ở loại vải này nhưng không ở màu đang chọn -> đổi màu
      var col = (data.options[iColor] && V.filter(function (v) { return match(v, st.size, null, st.fab); }).map(function (v) { return v.o[iColor]; })[0]) || null;
      if (col) {
        fix.color = col;
        var cols = []; V.forEach(function (v) { if (match(v, st.size, null, st.fab) && cols.indexOf(v.o[iColor]) < 0) cols.push(v.o[iColor]); });
        note = [st.fab, st.size].filter(Boolean).join(' ') + ' comes in ' + cols.join(' & ');
      } else fix.size = nearest(st.size, sizesFor(st.color, st.fab));
    } else {
      var ns = nearest(st.size, sizesFor(st.color, st.fab));
      if (ns) fix.size = ns;
      else {
        var c2 = V.filter(function (v) { return match(v, st.size, null, st.fab); }).map(function (v) { return v.o[iColor]; })[0];
        if (c2) fix.color = c2; else { fix.size = nearest(st.size, sizesFor(null, st.fab)); fix.color = V.filter(function (v) { return match(v, fix.size, null, st.fab); }).map(function (v) { return iColor >= 0 ? v.o[iColor] : null; })[0]; }
      }
      if (fix.size !== st.size) {
        var inFab = sizesFor(null, st.fab);
        if (inFab.indexOf(st.size) < 0) note = (st.fab || 'This style') + ' comes in ' + ranges(inFab);
        else note = [fix.color, st.fab].filter(Boolean).join(' ') + ' comes in ' + ranges(sizesFor(fix.color, st.fab));
      }
    }
    if (fix.size !== st.size) check('size', fix.size);
    if (fix.color !== st.color) check('color', fix.color);
  }, true);

  // Ô màu gạch chéo: chặn bấm
  document.addEventListener('click', function (ev) {
    var lb = ev.target && ev.target.closest && ev.target.closest('.product-details label.sfx-x');
    if (lb) { ev.preventDefault(); ev.stopPropagation(); }
  }, true);

  var lastSel = null;
  function syncChecked() {
    var form = root().querySelector('variant-picker .variant-picker__form, .variant-picker__form'); if (!form) return;
    var js = form.querySelector('script[type="application/json"]'); if (!js) return;
    var txt = js.textContent; if (txt === lastSel) return; // chỉ chạy khi Horizon vừa vẽ lại (biến thể mới) hoặc lần đầu
    var v; try { v = JSON.parse(txt); } catch (e) { return; }
    lastSel = txt; if (!v || !v.options) return;
    ['size', 'color', 'fabric'].forEach(function (k) {
      var idx = k === 'size' ? iSize : k === 'color' ? iColor : iFab; if (idx < 0) return;
      var fs = fsOf(k); if (!fs) return;
      var want = v.options[idx]; if (want == null) return;
      var inputs = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (!inputs.some(function (i) { return i.value === want; })) return;
      inputs.forEach(function (i) {
        var on = i.value === want;
        if (i.checked !== on) i.checked = on;
        if (on && !i.hasAttribute('checked')) i.setAttribute('checked', '');
        if (!on && i.hasAttribute('checked')) i.removeAttribute('checked');
        if (i.dataset.currentChecked !== (on ? 'true' : 'false')) i.dataset.currentChecked = on ? 'true' : 'false';
      });
    });
  }

  var busy = false;
  function apply() {
    if (busy) return; busy = true;
    try {
      var fSize = fsOf('size'), fColor = fsOf('color'), fFab = iFab >= 0 ? fsOf('fabric') : null;
      var st = state(), size = st.size, color = st.color, fab = st.fab || 'Classic';
      var fabQ = iFab >= 0 ? (st.fab || null) : null;

      // 0) Lớp an toàn (B5 6/10): sau mỗi lần Horizon vẽ lại, mỗi nhóm có ĐÚNG 1 input checked khớp biến thể đang chọn
      syncChecked();
      // 1) Dòng giải thích + "from $X" (Fabric lên trên Size bằng CSS order, KHÔNG di chuyển DOM — B5 6/10)
      if (fFab) {
        fFab.classList.add('sfx-fabric');
        fFab.querySelectorAll('label').forEach(function (lb) {
          var val = labelValue(lb); if (!/^(classic|premium)$/i.test(val)) return;
          var min = Infinity; V.forEach(function (v) { if (v.o[iFab] === val && (iColor < 0 || !color || v.o[iColor] === color) && v.p < min) min = v.p; });
          var txt = (lines[val] || '') + (isFinite(min) ? (lines[val] ? ' · ' : '') + 'from ' + money(min) : '');
          var sm = lb.querySelector('.sfx-fabric-desc');
          if (!sm) { sm = document.createElement('small'); sm.className = 'sfx-fabric-desc'; lb.appendChild(sm); }
          if (sm.textContent !== txt) sm.textContent = txt;
        });
      }

      // 2a) Size: ẩn khi không có ở BẤT KỲ màu nào của loại vải đang chọn
      if (fSize && iSize >= 0) fSize.querySelectorAll('label').forEach(function (lb) {
        var ok = has(labelValue(lb), null, fabQ); lb.classList.toggle('sfx-na', !ok);
        var inp = inputOf(lb); if (inp) inp.classList.toggle('sfx-na', !ok);
      });
      // 2b) Color: tổ hợp không có -> gạch chéo + tooltip
      if (fColor && iColor >= 0) fColor.querySelectorAll('label').forEach(function (lb) {
        var val = labelValue(lb), anyFab = has(null, val, fabQ), ok = has(size, val, fabQ);
        lb.classList.toggle('sfx-na', !anyFab);
        lb.classList.toggle('sfx-x', anyFab && !ok);
        var tip = anyFab && !ok ? 'Not available in this size' : '';
        if ((lb.getAttribute('title') || '') !== tip) { if (tip) lb.setAttribute('title', tip); else lb.removeAttribute('title'); }
        var inp = inputOf(lb); if (inp) { inp.classList.remove('sfx-na'); if (tip) inp.setAttribute('aria-disabled', 'true'); else inp.removeAttribute('aria-disabled'); }
      });

      // 3) Phụ thu size: so với giá thấp nhất cùng màu + cùng chất liệu
      if (fSize && iSize >= 0) {
        var pool = V.filter(function (v) { return match(v, null, color, fabQ); });
        var base = Infinity; pool.forEach(function (v) { if (v.p < base) base = v.p; });
        fSize.querySelectorAll('label').forEach(function (lb) {
          var val = labelValue(lb), v = pool.find(function (x) { return x.o[iSize] === val; });
          var extra = v && isFinite(base) ? v.p - base : 0, txt = extra > 0 ? '+' + money(extra) : '';
          var sm = lb.querySelector('.sfx-size-extra');
          if (txt && !sm) { sm = document.createElement('small'); sm.className = 'sfx-size-extra'; lb.appendChild(sm); }
          if (sm && sm.textContent !== txt) { if (txt) sm.textContent = txt; else sm.remove(); }
        });
      }

      // 3b) Link "Size guide" (in đậm) cạnh nhãn SIZE
      var pop = document.querySelector('.product-details dialog-component.popup-link');
      if (pop) pop.classList.add('sfx-sg-host');
      var leg = fSize && fSize.querySelector('legend');
      if (leg && pop && !leg.querySelector('.sfx-sg-link')) {
        var a = document.createElement('button'); a.type = 'button'; a.className = 'sfx-sg-link'; a.textContent = 'Size guide';
        a.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); var p2 = document.querySelector('.product-details dialog-component.popup-link'); if (p2 && typeof p2.showDialog === 'function') p2.showDialog(); else { var b = p2 && p2.querySelector('.popup-link__button'); if (b) b.click(); } });
        leg.appendChild(a);
      }

      // 3c) Dòng ghi chú dưới Size khi đã tự chuyển size
      if (fSize) {
        var nt = fSize.querySelector('.sfx-size-note');
        if (note) {
          if (!nt) { nt = document.createElement('p'); nt.className = 'sfx-size-note'; nt.setAttribute('role', 'status'); fSize.appendChild(nt); }
          if (nt.textContent !== note) nt.textContent = note;
        } else if (nt) nt.remove();
      }

      // 4) Dòng gần giá + ô Fit & fabric + tab bảng size theo bản đang chọn
      document.querySelectorAll('[data-sfx-fabric-line]').forEach(function (el) { var t = el.dataset[fab.toLowerCase()] || el.dataset.classic; if (t && el.textContent !== t) el.textContent = t; });
      document.querySelectorAll('.sfx-fit-info__block[data-fabric]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.fabric === fab); });
      if (fab !== (apply._fab || 'Classic')) {
        document.querySelectorAll('.sfx-sizechart__tabs input[value="' + fab + '"]').forEach(function (r) { r.checked = true; });
      }
      apply._fab = fab;
    } catch (e) { /* không làm hỏng trang */ }
    busy = false;
  }
  function go() {
    apply();
    var r = root(); if (r && r !== document) new MutationObserver(function () { apply(); }).observe(r, { childList: true, subtree: true });
    document.addEventListener('change', function () { setTimeout(apply, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
